module.exports = __webpack_public_path__ + "static/media/meezi-section-1.aac66e87.png";